import {
  GET_ACTIVE_PROMO_EVENT_SUCCESS,
  } from "./actionTypes"
  
  const initialState = {
    data:[],
  }
  
  const getActivePromoEventR = (state = initialState, action) => {
    switch (action.type) {
      case GET_ACTIVE_PROMO_EVENT_SUCCESS:
        state = { ...state, data: action.payload.response };
        return state;
    }
    return state
  }
  
  export default getActivePromoEventR
  